import { h } from 'preact';
import * as BaseComp from 'components/bolt/footer/sonyFooter.js';
import { findInVNode } from 'utils/vnode';
import s from 'components/bolt/footer/sonyFooter.sss';

export default class SonyFooter extends BaseComp.default {

	render (props) {
		const base = super.render(props);
		const creditButton = findInVNode(base, '#sonyCreditButton');
		const caret = <span class={s.caret}>&#9650;</span>;
		if (creditButton) {
			creditButton.children.push(caret);
		}
		return base;
	}

}